module.exports = __webpack_public_path__ + "img/Elec_super_batterie-1536x864.33a036e3.jpg";